import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import LogoImage from "../images/decodia-logo.png";

import newProject1 from "../images/newProject/newProject1.png";
import newProject11 from "../images/newProject/newProject11.png";
import newProject10 from "../images/newProject/newProject10.png";
import newProject13 from "../images/newProject/newProject13.png";
import newProject15 from "../images/newProject/newProject15.jpg";
import newProject4 from "../images/newProject/newProject4.jpg";
import newProject5 from "../images/newProject/newProject5.jpg";
import newProject8 from "../images/newProject/newProject8.png";
import newProject12 from "../images/newProject/newProject12.png";

const Footer = () => {
  const colors = {
    charcoalGrey: "#0d1117",
    charcoalMedium: "#161b22",
    charcoalLight: "#21262d",
    terracotta: "#ff6b35",
    terracottaLight: "#ff8e53",
    terracottaDark: "#e55a2b",
    softOlive: "#38b2ac",
    softOliveLight: "#4fd1c5",
    softOliveDark: "#319795",
    gold: "#d4af37",
    lightGold: "#f1c40f",
    platinum: "#e5e7eb",
    pureWhite: "#ffffff",
    accentPurple: "#9f7aea",
    accentBlue: "#4299e1",
  };

  const galleryImages = [
    newProject1,
    newProject10,
    newProject11,
    newProject13,
    newProject15,
    newProject4,
    newProject5,
    newProject8,
    newProject12,
  ];

  return (
    <Box className="footer-wrapper">
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 8 }}>
          {/* Logo and Brand Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Box className="footer-logo-container">
              <img
                src={LogoImage}
                className="footer-logo"
                alt="Decodia"
                style={{
                  height: 100,
                  width: "auto",
                  marginBottom: 16,
                  filter: "drop-shadow(0 4px 12px rgba(255, 107, 53, 0.3))",
                }}
              />

              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 800,
                  margin: 0,
                  mb: 1,
                  fontFamily: "'Playfair Display', serif",
                  color: colors.pureWhite,
                  lineHeight: 1.2,
                }}
              >
                Decodia Design Studio
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.95rem",
                  mb: 3,
                  fontWeight: 600,
                  color: colors.terracottaLight,
                  letterSpacing: "0.5px",
                }}
              >
                Where Design Meets Innovation
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                <IconButton
                  component="a"
                  href="https://www.facebook.com/decodiadesignstudio"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: colors.pureWhite,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: colors.terracotta,
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px ${colors.terracotta}40`,
                    },
                  }}
                >
                  <FacebookIcon />
                </IconButton>

                <IconButton
                  component="a"
                  href="https://www.instagram.com/decodiadesignstudio/?igsh=MXVrMmgzMHdxeG1wcg%3D%3D#"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: colors.pureWhite,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#E4405F",
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px #E4405F40`,
                    },
                  }}
                >
                  <InstagramIcon />
                </IconButton>
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/company/decodiadesignsstudio/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: colors.pureWhite,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#0A66C2",
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px #0A66C240`,
                    },
                  }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>

          {/* Quick Links Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              className="footer-section-title"
              sx={{
                fontSize: "1.2rem",
                fontWeight: 700,
                mb: 3,
                fontFamily: "'Playfair Display', serif",
                color: colors.pureWhite,
                position: "relative",
                display: "inline-block",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: 30,
                  height: "2px",
                  background: colors.terracotta,
                  borderRadius: "1px",
                },
              }}
            >
              Quick Links
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Typography
                sx={{
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  mb: 2,
                  color: colors.terracottaLight,
                }}
              >
                Our Gallery
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                <Link
                  href="/"
                  className="footer-link"
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      color: colors.terracottaLight,
                      transform: "translateX(4px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: colors.terracotta,
                      opacity: 0.7,
                    }}
                  />
                  Home
                </Link>
                <Link
                  href="/about"
                  className="footer-link"
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      color: colors.terracottaLight,
                      transform: "translateX(4px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: colors.terracotta,
                      opacity: 0.7,
                    }}
                  />
                  About Us
                </Link>
                <Link
                  href="/services"
                  className="footer-link"
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      color: colors.terracottaLight,
                      transform: "translateX(4px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: colors.terracotta,
                      opacity: 0.7,
                    }}
                  />
                  Services
                </Link>
                <Link
                  href="/portfolio"
                  className="footer-link"
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      color: colors.terracottaLight,
                      transform: "translateX(4px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: colors.terracotta,
                      opacity: 0.7,
                    }}
                  />
                  Portfolio
                </Link>
                <Link
                  href="/blog"
                  className="footer-link"
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      color: colors.terracottaLight,
                      transform: "translateX(4px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: colors.terracotta,
                      opacity: 0.7,
                    }}
                  />
                  Blog
                </Link>
                <Link
                  href="/contact"
                  className="footer-link"
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      color: colors.terracottaLight,
                      transform: "translateX(4px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: colors.terracotta,
                      opacity: 0.7,
                    }}
                  />
                  Contact
                </Link>
              </Box>
            </Box>
          </Grid>
          {/* Gallery Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              className="footer-section-title"
              sx={{
                fontSize: "1.2rem",
                fontWeight: 700,
                mb: 3,
                fontFamily: "'Playfair Display', serif",
                color: colors.pureWhite,
                position: "relative",
                display: "inline-block",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: 30,
                  height: "2px",
                  background: colors.softOlive,
                  borderRadius: "1px",
                },
              }}
            >
              Our Gallery
            </Typography>

            <Box className="footer-gallery-grid">
              {galleryImages.map((img, index) => (
                <Box
                  key={index}
                  component="img"
                  src={img}
                  className="footer-gallery-image"
                  sx={{
                    width: "95px",
                    height: "95px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: `0 8px 25px ${colors.charcoalGrey}80`,
                    },
                  }}
                />
              ))}
            </Box>
          </Grid>

          {/* Contact Info Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              className="footer-section-title"
              sx={{
                fontSize: "1.2rem",
                fontWeight: 700,
                mb: 3,
                fontFamily: "'Playfair Display', serif",
                color: colors.pureWhite,
                position: "relative",
                display: "inline-block",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: 30,
                  height: "2px",
                  background: colors.accentBlue,
                  borderRadius: "1px",
                },
              }}
            >
              Contact Info
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Box
                className="footer-contact-row"
                sx={{ alignItems: "flex-start" }}
              >
                <PhoneIcon
                  sx={{
                    color: colors.terracotta,
                    fontSize: 20,
                    mt: 0.5,
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ ml: 2 }}>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    +91 8100364941
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    +91 83708 25457
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      color: "rgba(255, 255, 255, 0.7)",
                      mt: 0.5,
                    }}
                  >
                    Call us anytime
                  </Typography>
                </Box>
              </Box>

              <Box
                className="footer-contact-row"
                sx={{ alignItems: "flex-start" }}
              >
                <EmailIcon
                  sx={{
                    color: colors.softOlive,
                    fontSize: 20,
                    mt: 0.5,
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ ml: 2 }}>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    decodiaofficial@gmail.com
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    info@decodia.in
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      color: "rgba(255, 255, 255, 0.7)",
                      mt: 0.5,
                    }}
                  >
                    Response within 24 hours
                  </Typography>
                </Box>
              </Box>

              <Box
                className="footer-contact-row"
                sx={{ alignItems: "flex-start" }}
              >
                <LocationOnIcon
                  sx={{
                    color: colors.accentBlue,
                    fontSize: 20,
                    mt: 0.5,
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ ml: 2 }}>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    Decodia 
                  </Typography>
                   <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                   P S Abacus - 703, 7th Floor
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    NH12, Action Area IIE, Newtown
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: colors.pureWhite,
                      lineHeight: 1.4,
                    }}
                  >
                    West Bengal 700161
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      color: "rgba(255, 255, 255, 0.7)",
                      mt: 0.5,
                    }}
                  >
                    Visit our studio
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright Section */}
        <Box className="footer-copyright" sx={{ mt: 6, pt: 4 }}>
          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "rgba(255, 255, 255, 0.7)",
              textAlign: "center",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            © 2023 Decodia Design Studio. All Rights Reserved.
          </Typography>
          
          {/* ✅ Privacy Policy Link Added Here */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            <Link
              href="/privacy-policy"
              sx={{
                fontSize: "0.8rem",
                color: "rgba(255, 255, 255, 0.5)",
                textDecoration: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: colors.terracottaLight,
                  textDecoration: "underline",
                },
              }}
            >
              Privacy Policy
            </Link>
          </Box>
          
          <Typography
            sx={{
              fontSize: "0.8rem",
              color: "rgba(255, 255, 255, 0.5)",
              textAlign: "center",
              mt: 1,
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Premium Interior Design Services • 5-Star Rated • Satisfying Projects
            Completed
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;